const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/public/session-feedback.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import type { SupportedLanguage } from '@/i18n';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/public/session-feedback')({
  validateSearch: search => {
    return {
      redirectToken: search.redirectToken as string ?? '',
      cycleId: search.cycleId as string ?? '',
      sessionId: search.sessionId as string ?? '',
      cycleStartDate: search.cycleStartDate as string ?? '',
      lang: search.lang as SupportedLanguage ?? 'ko',
      isLastSession: search.isLastSession === true || search.isLastSession === 'true'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}